export const CLOSE_CONSUMPTION_BYPASS_MODAL = 'CLOSE_CONSUMPTION_BYPASS_MODAL'
export const SHOW_CONSUMPTION_BYPASS_MODAL = 'SHOW_CONSUMPTION_BYPASS_MODAL'

export interface ShowConsumptionBypassModalAction {
  type: typeof SHOW_CONSUMPTION_BYPASS_MODAL
  title: string
}

export interface CloseConsumptionBypassModalAction {
  type: typeof CLOSE_CONSUMPTION_BYPASS_MODAL
}

export type ConsumptionBypassModalAction =
  | ShowConsumptionBypassModalAction
  | CloseConsumptionBypassModalAction

export const showConsumptionBypassModal = ({
  title,
}: {
  title?: string
}): ShowConsumptionBypassModalAction => {
  const resolvedTitle =
    title || 'Are you sure you want to create an order from this Proposal?'

  return { type: SHOW_CONSUMPTION_BYPASS_MODAL, title: resolvedTitle }
}

export const closeConsumptionBypassModal =
  (): CloseConsumptionBypassModalAction => ({
    type: CLOSE_CONSUMPTION_BYPASS_MODAL,
  })
